import React from 'react';
import styled from '@emotion/native';
import { green, lightGreen, sand } from '@/shared/styles/colors';
import { BodyText } from '../StyledText';
import { View } from 'react-native';
import useBreakpoint from '@/shared/hooks/useBreakpoint';
import { getPaddingHorizontal } from './utils';
import { ReceiptLabelText } from './constants';
export interface ReceiptItemProps {
  label: ReceiptLabelText;
  value?: string;
  icon?: React.ReactNode;
  hideBorder?: boolean;
  customElement?: React.ReactNode;
  subText?: React.ReactNode;
}

const ReceiptItem: React.FC<ReceiptItemProps> = ({
  label,
  value,
  icon,
  hideBorder = false,
  customElement,
  subText,
}) => {
  const { isDesktop } = useBreakpoint();
  const lowercaseLabels = ['Duration', 'Date and Time'];

  return (
    <Container paddingHorizontal={getPaddingHorizontal(isDesktop)}>
      <ReceiptRow hideBorder={hideBorder}>
        <LeftContainer
          isDesktop={isDesktop}
          isPromoCode={label === ReceiptLabelText.PromoCode}
        >
          <ReceiptLabel style={{ marginBottom: Boolean(subText) ? 4 : 0 }}>
            {label}
          </ReceiptLabel>
          {subText && subText}
        </LeftContainer>
        <RightContainer>
          <View>
            <View style={{ height: 2 }} />
            {icon && icon}
          </View>
          {customElement ? (
            customElement
          ) : (
            // Handle case where value is UPPERCASE the transform in css
            <ReceiptValue
              caseStyle={
                lowercaseLabels.includes(label) ? 'lowercase' : 'capitalize'
              }
            >
              {value?.toLocaleLowerCase()}
            </ReceiptValue>
          )}
        </RightContainer>
      </ReceiptRow>
    </Container>
  );
};

const Container = styled.View(
  ({ paddingHorizontal = 26 }: { paddingHorizontal: number }) => ({
    paddingHorizontal,
  }),
);

const ReceiptRow = styled.View<{ hideBorder: boolean }>(({ hideBorder }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingVertical: 20,
  borderBottomWidth: hideBorder ? 0 : 1,
  borderBottomColor: sand,
}));

const RightContainer = styled.View({
  flexDirection: 'row',
  alignItems: 'flex-start',
});

const LeftContainer = styled.View(
  ({
    isDesktop,
    isPromoCode,
  }: {
    isDesktop: boolean;
    isPromoCode: boolean;
  }) => ({
    maxWidth: isDesktop ? 'auto' : 210,
    alignSelf: isPromoCode ? 'flex-start' : 'center',
    paddingTop: isPromoCode ? 10 : 0,
  }),
);

export const ReceiptIcon = styled.Image({
  marginRight: 5,
  height: 20,
  width: 20,
  resizeMode: 'contain',
});

export const ReceiptLabel = styled(BodyText)({
  fontSize: 14,
  color: green,
  fontWeight: 'medium',
  lineHeight: 18,
});

export const ReceiptValue = styled(BodyText)(
  ({
    caseStyle = 'capitalize',
  }: {
    caseStyle?: 'capitalize' | 'lowercase';
  }) => ({
    fontSize: 15,
    color: lightGreen,
    fontWeight: 'regular',
    lineHeight: 18,
    textTransform: caseStyle,
    maxWidth: 210,
    textAlign: 'right',
  }),
);

export default ReceiptItem;
